<template>
  <Layout>
    <PageHeader :title="title" :items="braedcrumb" />
    <div>
      <b-row>
        <b-col>
          <b-card>
            <b-row>
              <b-col sm="12" md="4">
                <div>
                  <label>{{ $t("headertext") }}</label>

                  <b-form-input
                    :placeholder="$t('headertext')"
                    v-model="Instruction.headertext"
                    type="text"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col sm="12" md="4">
                <div>
                  <label>{{ $t("ondate") }}</label>
                  <date-picker
                    v-model="Instruction.dateofcreated"
                    valueType="format"
                    style="width:100%"
                    size="sm"
                    lang="ru"
                    :placeholder="$t('date')"
                    value-type="format"
                    format="DD.MM.YYYY"
                  ></date-picker>
                </div>
              </b-col>
              <b-col>
                <label>{{ $t("Type") }}</label>
                <v-select
                  :options="TypeList"
                  :reduce="(item) => item.id"
                  :placeholder="$t('ChooseBelow')"
                  label="name"
                  v-model="Instruction.typeid"
                ></v-select>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div class="form-group form-row">
                  <label class="col-form-label col-sm-12">{{
                    $t("fileupload")
                  }}</label>
                  <b-form-file
                    v-model="file"
                    @change="ChangeFile"
                    browse-text=""
                    placeholder=""
                    ref="file-input"
                  ></b-form-file>
                </div>
              </b-col>
            </b-row>

            <b-row v-if="url1.length > 0" class="mt-1">
              <b-col
                sm="6"
                md="3"
                lg="2"
                v-for="(item, index) in url1"
                :key="index"
                v-show="item.Status != 3"
              >
                <b-card
                  class="text-center"
                  bg-variant="info"
                  text-variant="white"
                >
                  <div>
                    <h6 class="mb-25 font-weight-bolder text-white">
                      {{ item.name }}
                    </h6>
                    <div>
                      <b-link>
                        <i
                          style="cursor:pointer;font-size:20px;"
                          @click="myFunction(item.index)"
                          class="bx bx-trash-alt"
                        ></i>
                      </b-link>
                    </div>
                  </div>
                </b-card>
              </b-col>
            </b-row>
            <b-row v-if="Instruction.Files && Instruction.Files.length > 0">
              <b-col
                sm="12"
                md="3"
                lg="2"
                v-for="(item, index) in LoadImage"
                :key="index"
                v-show="item.Status != 3"
              >
                >
                <b-card
                  class="text-center"
                  bg-variant="info"
                  text-variant="white"
                >
                  <div>
                    <h6 class="mb-25 font-weight-bolder text-white">
                      {{ item.attachfilename }}
                    </h6>
                    <div>
                      <b-link>
                        <i
                          style="cursor:pointer;font-size:20px"
                          @click="DownLoad(item)"
                          class="bx bx-download m-1"
                        ></i>
                      </b-link>
                      <b-link>
                        <i
                          style="cursor:pointer;font-size:20px"
                          @click="DeleteFile(item)"
                          class="bx bx-trash-alt"
                        ></i>
                      </b-link>
                    </div>
                  </div>
                </b-card>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-modal
        size="xl"
        :title="$t('translate')"
        v-model="translatemodal"
        no-close-on-backdrop
        hide-footer
      >
        <b-row>
          <b-col>
            <b-table
              :fields="translitefields"
              :items="translatelist"
              head-variant="primary"
              class="text-center"
              style="vertical-align:middle"
              bordered
              responsive="sm"
            >
              <template v-slot:thead-top>
                <b-tr>
                  <b-th style="width:30%">
                    <v-select
                      :options="LanguageList"
                      :reduce="(item) => item.id"
                      :placeholder="$t('ChooseBelow')"
                      label="fullname"
                      v-model="translaterow.languageid"
                    ></v-select>
                  </b-th>
                  <b-th style="width:60%">
                    <b-form-textarea v-model="translaterow.translatetext">
                    </b-form-textarea>
                  </b-th>
                  <b-th style="width:10%">
                    <b-button
                      @click="addtranslite"
                      color="primary"
                      variant="outline-primary"
                    >
                      <i class="bx bx-plus"> </i>
                    </b-button>
                  </b-th>
                </b-tr>
              </template>
              <template v-slot:cell(translatetext)="{ item }">
                <b-form-input
                  v-model="item.translatetext"
                  class="mb-0"
                ></b-form-input>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <b-row class="m-2 mt-2">
          <b-col class="text-center">
            <b-button
              class="m-2"
              @click="translatemodal = false"
              size="sm"
              variant="outline-danger"
            >
              <i class="dripicons-arrow-thin-left"></i>
              {{ $t("back") }}
            </b-button>
            <b-button
              class="m-2"
              @click="SaveTranslate"
              size="sm"
              variant="outline-success"
            >
              <i class="dripicons-checkmark"></i>
              {{ $t("Save") }}
            </b-button>
          </b-col>
        </b-row>
      </b-modal>
      <b-row>
        <b-col>
          <b-card>
            <b-row>
              <b-col class="text-right">
                <b-button
                  @click="$router.push('/info/Instruction')"
                  class="d-inline-block "
                  variant="danger"
                  ><i class="dripicons-arrow-thin-left"></i>
                  {{ $t("back") }}</b-button
                >
              </b-col>
              <b-col style="text-align: right !important; " class="text-right">
                <b-button
                  @click="SaveData"
                  class="d-inline-block "
                  variant="success"
                  ><i class="dripicons-checkmark"></i>
                  <b-spinner v-if="SaveLoading" small></b-spinner>
                  {{ $t("save") }}</b-button
                >
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </Layout>
</template>
<script>
import vSelect from "vue-select";
import DatePicker from "vue2-datepicker";
import Layout from "../../../router/layouts/main.vue";
import PageHeader from "@/components/page-header";
import InstructionService from "@/services/info/instruction.service";
import HelperService from "@/services/others/helper.service";
import Multiselect from "vue-multiselect";
import "vue2-datepicker/index.css";
import appConfig from "@/app.config";
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
export default {
  components: { DatePicker },
  page: {
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Multiselect,
    Layout,
    PageHeader,
    DatePicker,
    vSelect,
  },
  data() {
    return {
      title: this.$t("Instruction"),
      braedcrumb: [
        {
          text: this.$t("Info"),
        },
        {
          text: this.$t("Instruction"),
          active: true,
        },
      ],
      TypeList: [
        { id: 1, name: "Uzasbo" },
        { id: 2, name: "Erp" },
        { id: 3, name: "Bot" },
      ],
      SaveLoading: false,
      items: [],
      Instruction: { TranslatableColumns: [] },
      isLoading: false,
      translatemodal: false,
      fields: [
        {
          key: "text",
          label: this.$t("text"),
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "actions",
          label: this.$t("actions"),
          thClass: "text-center",
          sortable: true,
        },
      ],
      translitefields: [
        {
          key: "languagename",
          label: this.$t("languagename"),
          variant: "info",
        },
        { key: "translatetext", label: this.$t("name"), variant: "info" },
        { key: "actions", label: "", variant: "info" },
      ],
      translatelist: [],
      translaterow: {
        tableid: 0,
        tablerowid: 0,
        languageid: 0,
        languagename: "",
        columnname: "",
        translatetext: "",
      },
      translatebyname: "",

      InstructionList: [],
      LanguageList: [],
      editedIndex1: -1,
      lang: "ru",
      files: [],
      file: [],
      url1: [],
      LoadImage: [],
      DownloadLoading: false,
    };
  },
  created() {
    this.lang = localStorage.getItem("locale") || "ru";
    this.show = true;
    HelperService.GetListLanguages().then((res) => {
      this.LanguageList = res.data;
    });
    this.Refresh();
  },
  directives: {},
  methods: {
    Refresh() {
      InstructionService.Get(this.$route.params.id)
        .then((res) => {
          this.show = false;
          this.Instruction = res.data;
          // this.translatelist = res.data.Translates;
          this.LoadImage = res.data.Files;
          // this.Question.parentid = null;
        })
        .catch((error) => {
          this.$notification(error.response.data.error, "danger");
        });
    },
    forceFileDownload(response, name, attachfilename) {
      var headers = response.headers;
      var blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      let format = attachfilename.split(".");
      if (format.length > 0) {
        link.setAttribute(
          "download",
          format[0] + "." + format[format.length - 1]
        );
      }
      document.body.appendChild(link);
      link.click();
    },
    DownLoad(item) {
      this.DownloadLoading = true;
      InstructionService.GetDownloadFile(this.Instruction.id, item.id)
        .then((res) => {
          this.$notification(
            this.$t("SuccessDownload"),
            this.$t("message"),
            "success"
          );
          this.forceFileDownload(res, item.id, item.attachfilename);
          //   this.src = window.URL.createObjectURL(new Blob([res.data]))
          this.DownloadLoading = false;
        })
        .catch((err) => {
          // console.log(err.response.data.error);
          this.$notification(
            err.response.data.error,
            this.$t("error"),
            "danger"
          );
          this.DownloadLoading = false;
        });
    },
    myFunction(index) {
      this.url1.splice(index, 1);
      this.$refs["file-input"].reset();
    },
    DeleteFile(item) {
      this.DeleteLoading = true;
      InstructionService.DeleteFile(item.id)
        .then((res) => {
          // console.log(item);
          item.Status = 3;
          // documentService.Get(this.$route.params.id).then((res) => {
          //   // this.Document.TablesFile = res.data.TablesFile;
          //   this.Document = res.data;
          // });
          // console.log(item);
          // this.Document.TablesFile.forEach(function(el) {
          //   if (item.id == el.fileid) {
          //     el.Status = 3;
          //   }
          // });

          this.$notification(
            this.$t("SuccessDelete"),
            this.$t("message"),
            "success"
          );
          this.DeleteLoading = false;
          this.Refresh();
        })
        .catch((error) => {
          this.$notification(
            error.response.data.error,
            this.$t("error"),
            "danger"
          );
          this.DeleteLoading = false;
        });
    },
    ChangeFile(e) {
      const file = e.target.files[0];
      if (!!e.target.files[0]) {
        this.url1.push({
          name: e.target.files[0].name,
          url: URL.createObjectURL(file),
          file: e.target.files[0],
        });
      }
      this.files.push(file);
    },

    OpenQuestionModal() {
      this.QuestionModal = true;
    },
    translate(selectcolumnname) {
      var self = this;
      self.translatebyname = selectcolumnname;
      self.translatelist = self.Instruction.Translates.filter(
        (item) => item.columnname == selectcolumnname
      );
      self.translatemodal = true;
    },
    addtranslite() {
      var self = this;
      if (
        self.translaterow.languageid === 0 ||
        self.translaterow.languageid === undefined ||
        self.translaterow.languageid === null
      ) {
        this.$notification(
          this.$t("languageidNotSelect"),
          this.$t("Error"),
          "danger"
        );
      } else if (
        self.translaterow.translatetext === "" ||
        self.translaterow.translatetext === undefined ||
        self.translaterow.translatetext === null
      ) {
        this.$notification(
          this.$t("translatetextNotSelect"),
          this.$t("Error"),
          "danger"
        );
      } else {
        var dublikate = false;
        self.translatelist.forEach((item) => {
          if (item.languageid === self.translaterow.languageid) {
            this.$notification(
              this.$t("dublikate"),
              this.$t("Error"),
              "danger"
            );
            dublikate = true;
          }
        });
        if (!dublikate) {
          self.translaterow.languagename = self.LanguageList.filter(
            (item) => item.id === self.translaterow.languageid
          )[0].fullname;
          self.translaterow.columnname = self.translatebyname;
          self.translatelist.push(self.translaterow);
          self.translaterow = {
            tableid: 0,
            tablerowid: 0,
            languageid: 0,
            languagename: "",
            columnname: "",
            translatetext: "",
          };
        }
      }
    },
    SaveTranslate() {
      var self = this;
      self.Instruction.Translates = self.Instruction.Translates.filter(
        (x) => x.columnname !== self.translatebyname
      );
      self.translatelist.forEach((item) => {
        self.Instruction.Translates.push(item);
      });
      self.translatemodal = false;
    },
    rowClass(item, type) {
      if (item.Status === 3) return "d-none";
    },
    Edit(item) {
      if (item.Status == 0) {
        item.Status = 2;
      }
      this.editedIndex1 = this.Instruction.Tables.indexOf(item);
      this.tabrow = Object.assign({}, item);
      this.ModalShow = true;
    },
    DeleteRow(item) {
      item.Status = 3;
    },
    AddRow() {
      if (this.editedIndex1 > -1) {
        Object.assign(this.Instruction.Tables[this.editedIndex1], this.tabrow);
      } else {
        this.Instruction.Tables.push(this.tabrow);
      }
      this.ModalShow = false;
    },
    OpenModal() {
      this.ModalShow = true;
      this.tabrow = {
        id: 0,
        ownerid: 0,
        text: "",
        Status: 1,
      };
      this.editedIndex1 = -1;
    },
    check() {
      if (
        this.Instruction.description === 0 ||
        this.Instruction.description === null ||
        this.Instruction.description === undefined ||
        this.Instruction.description === ""
      ) {
        this.$notification(this.$t("descriptionNotSelected"), "danger");
        return false;
      }
      if (
        this.Instruction.name === 0 ||
        this.Instruction.name === null ||
        this.Instruction.name === undefined ||
        this.Instruction.name === ""
      ) {
        this.$notification(this.$t("nameNotSelected"), "danger");
        return false;
      }

      return true;
    },
    SaveData() {
      var formData = new FormData();
      formData.append("id", this.Instruction.id);
      formData.append("headertext", this.Instruction.headertext);
      formData.append("dateofcreated", this.Instruction.dateofcreated);
      formData.append("typeid", this.Instruction.typeid);
      formData.append("Files", []);
      this.url1.forEach((file, i) => {
        formData.append("attachedfiles", file.file);
      });
      this.SaveLoading = true;
      InstructionService.Update(formData)
        .then((res) => {
          this.SaveLoading = false;
          this.$notification(this.$t("SaveSuccess"), "success");
          this.$router.push({ name: `Instruction` });
        })
        .catch((err) => {
          this.SaveLoading = false;
          this.$notification(this.$t(err.response.data.error), "danger");
        });
    },
  },
};
</script>

<style></style>
